import TenderInfo from './TenderInfo';;

export default TenderInfo;
